import * as Sentry from '@sentry/react';
import { WEB_VERSION } from '../version';

if (import.meta.env.PROD) {
  Sentry.init({
    integrations: [],
    sendDefaultPii: true,
    release: `checkout-web@${WEB_VERSION}`,
    environment: import.meta.env.CHECKOUT_WEB_ENV,
    dsn: 'https://20b682b578ca1c99065a74e09ec0ecb4@o4506932402454528.ingest.us.sentry.io/4509672046592000',
    ignoreErrors: ['Non-Error promise rejection captured'],
  });
}
